import { render, staticRenderFns } from "./OpportunitySettingForm.vue?vue&type=template&id=25e415e5&"
import script from "./OpportunitySettingForm.vue?vue&type=script&lang=js&"
export * from "./OpportunitySettingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports